/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const SET_UI_THEME = 'uiActionTypes/SET_UI_THEME';
export const SET_UI_THEME_SUCCESS = 'uiActionTypes/SET_UI_THEME_SUCCESS';
export const SET_UI_THEME_FAILURE = 'uiActionTypes/SET_UI_THEME_FAILURE';

export interface SetUiTheme {
  type: typeof SET_UI_THEME;
  payload?:any,
}

export interface SetUiThemeSuccess {
  type: typeof SET_UI_THEME_SUCCESS;
  payload?:any;
}

export interface SetUiThemeFailure {
  type: typeof SET_UI_THEME_FAILURE;
  payload?:any;
}
